module.exports = __webpack_public_path__ + "media/images/athletes/4156-f56030e095d6ef5249561c8794804d77.png";